import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../Accordion';
import { SectionLabel } from './SectionLabel';
const FAQS = [{
  q: 'What size projects do you take on?',
  a: 'Everything from small repairs and single-room updates to complete interior and exterior transformations. As a full-service general contractor, we scale the crew and schedule to the scope.'
}, {
  q: 'How does pricing work?',
  a: 'After the walkthrough we provide a written quote with scope, materials, and allowances spelled out. Any change is documented and approved before the work happens.'
}, {
  q: 'How long will my project take?',
  a: 'It depends on scope, but you receive a schedule before construction starts. Most kitchens and baths run five to eight weeks; whole-home remodels typically run three to four months.'
}, {
  q: 'Are you licensed and insured?',
  a: 'Yes. Licensing and insurance documentation is provided with every quote, along with references from comparable projects.'
}, {
  q: 'Do you handle design and selections?',
  a: 'We do. We help plan layouts and guide material and finish selections, then manage planning, construction, and finishing as one process.'
}];
export function FaqSection() {
  return <section className="w-full bg-bone-50 py-24 sm:py-32" aria-labelledby="faq-heading" data-id="element-92" data-mp="124onfiv3875j">
      <div className="mx-auto max-w-[1320px] px-6 lg:px-10" data-id="element-93" data-mp="1g4fypbu7z9fu">
        <div className="grid gap-12 lg:grid-cols-12" data-id="element-94" data-mp="1g2mmlh0u7x0g">
          <div className="lg:col-span-4" data-id="element-95" data-mp="1b4utijogi4uo">
            <SectionLabel data-id="element-96" data-mp="1b41xodr1czrb">Common Questions</SectionLabel>
            <h2 id="faq-heading" className="mt-7 font-display text-4xl font-light leading-[1.05] text-pine-950 sm:text-5xl" data-id="element-97" data-mp="1pthaeptqf4o0">
              Before you reach out.
            </h2>
          </div>
          <div className="lg:col-span-7 lg:col-start-6" data-id="element-98" data-mp="1yte63bejh3sk">
            <Accordion type="single" className="w-full" data-id="element-99" data-mp="1txf8qyb8gbg0">
              {FAQS.map((faq, i) => <AccordionItem key={faq.q} value={`item-${i}`} className="border-b border-pine-900/10" data-id="element-100" data-mp="rk0yuiuo2j79" data-mpi={i}>
                  <AccordionTrigger className="py-6 text-left font-display text-xl font-normal text-pine-950 hover:no-underline" data-id="element-101" data-mp="10j4hjlpx8wl8">
                    {faq.q}
                  </AccordionTrigger>
                  <AccordionContent className="pb-6 text-sm leading-relaxed text-pine-950/65" data-id="element-102" data-mp="1a9pn5t40j1dn">
                    {faq.a}
                  </AccordionContent>
                </AccordionItem>)}
            </Accordion>
          </div>
        </div>
      </div>
    </section>;
}